import { useSearchParams } from "react-router-dom";
import { useState } from "react";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [mensaje, setMensaje] = useState("");

  const handleReset = async () => {
    try {
      const res = await fetch(`${API_BASE}/colegiado/reset-password-request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
          nuevaPassword: password,
        }),
      });

      if (res.ok) {
        setMensaje("Contraseña actualizada correctamente");
      } else {
        setMensaje("Token inválido o expirado");
      }
    } catch {
      setMensaje("Error en el servidor");
    }
  };

  return (
    <div>
      <h2>Nueva contraseña</h2>

      <input
        type="password"
        placeholder="Nueva contraseña"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <button onClick={handleReset}>
        Cambiar contraseña
      </button>

      {mensaje && <p>{mensaje}</p>}
    </div>
  );
}

export default ResetPassword;